import { useEffect, useState } from 'react';
import { collection, getDocs, limit, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { db } from '../../firebase-config';
import { getYouTubeEmbed, isVideoFile } from './landingUtils';

// Projects the admin marked "prikaži na naslovnoj" (max 6), live.
export const useFeaturedProjects = () => {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    const q = query(collection(db, 'projects'), where('prikaziNaNaslovnoj', '==', true), limit(6));
    return onSnapshot(
      q,
      (snap) => setProjects(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
      (err) => console.error('Greška pri učitavanju projekata:', err)
    );
  }, []);
  return projects;
};

// Newest two playable films (video file or YouTube link), live.
export const useLatestFilms = () => {
  const [films, setFilms] = useState([]);
  useEffect(() => {
    const q = query(collection(db, 'films'), orderBy('createdAt', 'desc'));
    return onSnapshot(
      q,
      (snap) => {
        const items = [];
        snap.docs.forEach((d) => {
          const data = d.data();
          const url = (data.url || '').trim();
          const yt = getYouTubeEmbed(url);
          if (isVideoFile(url) || yt) {
            items.push({
              ...data,
              id: d.id,
              type: isVideoFile(url) ? 'file' : 'youtube',
              embed: yt || url,
              thumbnail: data.thumbnail || '',
            });
          }
        });
        setFilms(items.slice(0, 2));
      },
      (err) => console.error('Greška pri učitavanju filmova:', err)
    );
  }, []);
  return films;
};

// Published client reviews, newest first (max 9). Sorted here so Firestore
// doesn't need a composite index.
export const usePublishedReviews = () => {
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    let active = true;
    getDocs(query(collection(db, 'reviews'), where('status', '==', 'published'), limit(50)))
      .then((snap) => {
        if (!active) return;
        const items = snap.docs.map((d) => ({ ...d.data(), firestoreId: d.id }));
        items.sort((a, b) => new Date(b.submittedAt || b.createdAt) - new Date(a.submittedAt || a.createdAt));
        setReviews(items.slice(0, 9));
      })
      .catch((err) => console.error('Greška pri učitavanju recenzija:', err));
    return () => { active = false; };
  }, []);
  return reviews;
};
